import SelectComponent from '@components/inputs/select/Select.component';
import { Sizes } from '@constants/sizes.constants';
import { Stack, Typography } from '@mui/material';
import { AuditCollectContainerFrequency } from '@store/audits/audit/audit.model';
import {
  AuditOperationScheduleDto,
  CreateAuditOperation
} from '@store/audits/audits-operation/audits-operation.model';
import { getTypeOf } from '@utils/getTypeOf';
import { Fragment, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import DailyCollect from './collect/DailyCollect';
import MonthlyCollect from './collect/MonthlyCollect';
import WeeklyCollect from './collect/WeeklyCollect';

interface AuditContainerProps {
  auditOperation?: CreateAuditOperation;
  updateAuditOperation: <T extends keyof CreateAuditOperation>(
    field: T,
    value: CreateAuditOperation[T]
  ) => void;
}

const CollectInformations = (props: AuditContainerProps) => {

  const {
    auditOperation,
    updateAuditOperation
  } = props;

  const { t } = useTranslation();

  useEffect(() => {
    if (auditOperation) {
      if (auditOperation.schedule) {
        const frequencyobj = getTypeOf<AuditOperationScheduleDto>(auditOperation.schedule!);
        updateAuditOperation('frequency', { frequency: frequencyobj.frequency });
      }

    }
  }, [auditOperation?.schedule, updateAuditOperation, auditOperation]);

  return (
    <>
      <Stack direction="row" mt="3px" alignItems="center" spacing={0.5}>
        <Typography fontSize={20} fontWeight="700">
          {t('audits.audit.collect.informations')}
        </Typography>
      </Stack>
      <Stack py="24px" pr="10px" spacing={1.5}>
        <SelectComponent
          color="primary"
          labelWidth={Sizes.drawerInputLabelWidth}
          label={t('audits.audit.collect.frequency')}
          placeholder={t('global.select')}
          items={AuditCollectContainerFrequency.selectItems()}
          handleChange={(frequency) => updateAuditOperation('frequency', { frequency: frequency })}
          value={auditOperation?.frequency?.frequency ?? ''}
        />
        {[
          { type: 'MONTHLY', component: <MonthlyCollect auditOperation={auditOperation} updateAuditOperation={updateAuditOperation} /> },
          { type: 'WEEKLY', component: <WeeklyCollect auditOperation={auditOperation} updateAuditOperation={updateAuditOperation} /> },
          { type: 'DAILY', component: <DailyCollect auditOperation={auditOperation} updateAuditOperation={updateAuditOperation} /> }
        ].map((item) => auditOperation?.frequency?.frequency === item.type && <Fragment key={item.type}>{item.component}</Fragment>)}
      </Stack>
    </>
  );
};

export default CollectInformations;
